import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "info"
}
const _hoisted_2 = { class: "dialog-footer" }

import { onMounted, ref } from "vue";
import Avatar from "@/components/Avatar.vue";
import { useChatStore } from "@/store/chatStore";
import { useUserStore } from "@/store/userStore";
import { useRouter } from "vue-router";
import UserApi from "@/api/UserApi";
import DeptApi from "@/api/DeptApi";
import FriendApi from "@/api/FriendApi";
import Dept from "@/mode/Dept";
import User from "@/mode/User";
import ChatType from "@/config/ChatType";
import { ElMessage } from "element-plus/es";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserModal',
  props: {
  userId: {
    type: String,
    required: true,
    default: null,
  },
  showSend: {
    type: Boolean,
    required: false,
    default: false,
  },
  closeDialog: {
    type: Function,
    default: null,
  },
},
  setup(__props) {

const router = useRouter();
const store = useChatStore();
const userStore = useUserStore();
const isFriend = ref(true);
const open = ref(false);

const props = __props;

const user = ref<User>();
const depts = ref(new Array<Dept>());

const getIsFriend = () => {
  FriendApi.isFriend(props.userId).then((res) => {
    isFriend.value = res.data;
    if (props.userId === userStore.getUser()?.id) {
      isFriend.value = true;
    }
  });
};
const getUser = () => {
  UserApi.getUser(props.userId).then((res) => {
    user.value = res.data;
    // if (res.data.deptId == null || res.data.deptId === "null") {
    //   return;
    // } else {
    //   return DeptApi.parent(res.data.deptId).then((res) => {
    //     depts.value.splice(0, depts.value.length);
    //     res.data.forEach((item: Dept) => {
    //       depts.value.push(item);
    //     });
    //   });
    // }
  });
};

onMounted(() => {
  if (props.userId) {
    open.value = true;
    getUser();
    getIsFriend();
  }
});

const close = () => {
  props.closeDialog();
};

const addFriend = () => {
  if (!isFriend.value) {
    FriendApi.add(props.userId)
      .then(() => {
        isFriend.value = true;
        ElMessage.success("添加好友成功");
      })
      .catch(() => {
        ElMessage.error("添加好友失败");
      });
  }
};

const send = () => {
  props.closeDialog();
  if (user.value) {
    store.openChat({
      id: user.value.id,
      name: user.value.name,
      avatar: user.value.avatar,
      type: ChatType.FRIEND,
      lastMessage: "",
      unreadCount: 0,
      isLoading: false,
      loaded: true,
    });
  }
  router.push("/index/chat");
};

return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
    _createVNode(_component_el_dialog, {
      width: "40rem",
      center: "",
      "show-close": false,
      "close-on-click-modal": false,
      onClose: close,
      modelValue: open.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((open).value = $event))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_el_button, { onClick: close }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("关闭")
            ])),
            _: 1
          }),
          (!isFriend.value)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "info",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (addFriend()))
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("加好友")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (__props.showSend)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (send()))
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("聊天")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        (user.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(Avatar, {
                img: user.value.avatar,
                name: user.value.name
              }, null, 8, ["img", "name"]),
              _createVNode(_component_el_descriptions, {
                class: "description",
                column: 2
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions_item, { label: "姓名" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(user.value.name), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "性别" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(user.value.sex === "0" ? "男" : "女"), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "电话" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(user.value.mobile), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_descriptions_item, { label: "邮箱" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(user.value.email), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})